import Vue from "vue";
import Vuetify from "vuetify";
import store from "../store";
import "vuetify/dist/vuetify.min.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "md",
  },
  theme: {
    dark: store.state.darkMode,
    themes: {
      light: {
        primary: "#31a848",
        secondary: "#494a45",
        inverted: "#F5F5F5",
        accent: "#9c27b0",
        error: "#f44336",
        warning: "#607d8b",
        info: "#ffc107",
        success: "#cddc39",
      },
      dark: {
        primary: "#31a848",
        secondary: "#F5F5F5",
        inverted: "#000000",
        accent: "#9c27b0",
        error: "#f44336",
        warning: "#607d8b",
        info: "#ffc107",
        success: "#cddc39",
      },
    },
  },
});
